<template>
  <div id="doc_view">
    <iframe v-loading="isLoading" :src="pdfData"></iframe>
  </div>
</template>
<script>
import api from "@/api";
export default {
  name: "PdfViewer",
  data() {
    return {
      isLoading: true,
      pdfData: null
    };
  },
  mounted() {
    if (this.$route.query && this.$route.query.id) {
      let type = this.$route.query.type;
      if (type == "inventory") {
        api
          .get(`/api/v1/inventory/document_view/?id=${this.$route.query.id}`)
          .then(resp => {
            this.isLoading = false;
            this.pdfData = `data:application/pdf;base64,${resp.data.data.pdf}`;
          });
      } else if (type == "cmm") {
        api
          .get(`/api/v1/repair/cmm/view_file/${this.$route.query.id}/`)
          .then(resp => {
            this.isLoading = false;
            this.pdfData = `data:application/pdf;base64,${resp.data.data.pdf}`;
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#doc_view {
  height: 100vh;
  width: 100vw;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
